var dist = { exports: {} };
export {
  dist as __module
};
//# sourceMappingURL=index4.js.map
